module.exports = __webpack_public_path__ + "img/ex-graylogo.88ee636b.png";